import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { asset } from '../components/homepage/asset';
import NavigationHeader from '../components/homepage/NavigationHeader';
import Footer from '../components/homepage/Footer';

function ContactPage() {
  const { t } = useTranslation();
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [status, setStatus] = useState('idle');

  const canSubmit = useMemo(() => {
    return (
      form.name.trim().length > 0 &&
      form.email.trim().length > 0 &&
      form.phone.trim().length > 0 &&
      form.message.trim().length > 0
    );
  }, [form.email, form.message, form.name, form.phone]);

  function updateField(key) {
    return (event) => {
      const value = event.target.value;
      setForm((current) => ({ ...current, [key]: value }));
    };
  }

  function handleSubmit(event) {
    event.preventDefault();
    if (!canSubmit) return;

    setStatus('submitting');
    const subject = `Contact request from ${form.name}`.trim();
    const body = [
      `${t('contact_page.name')}: ${form.name}`,
      `${t('contact_page.email')}: ${form.email}`,
      `${t('contact_page.phone')}: ${form.phone}`,
      '',
      form.message,
    ].join('\n');

    window.location.href = `mailto:info@aazira.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    setStatus('submitted');
  }

  return (
    <main className="bg-slate-100 font-sans">
      <NavigationHeader />

      {/* <section className="md:mt-16 mt-20 opacity-[0.8] mx-auto">
             <img src={asset('contact-us.png')} alt="Contact us" className="h-full w-full object-cover max-h-[400px]" />
      </section> */}
      <section className="relative md:mt-16 mt-20 opacity-[0.8] mx-auto sm:max-w-[80%] max-w-[90%] py-14">
             <img src={asset('contact-us.png')} alt={t('contact_page.title')} className="h-full w-full object-cover" />
             <img src={asset('aazira-logo.png')} alt="aazira logo" className="h-auto w-[100px] absolute top-[50px] right-0 object-contain" />
      </section>

      <section className="mx-auto sm:max-w-[80%] max-w-[90%] py-14">
        <div className="rounded border border-gray-300 p-6 sm:p-8">
          <form onSubmit={handleSubmit}>
            <div className="grid gap-5 lg:grid-cols-2">
              <label className="grid gap-2">
                <span className="text-xs font-extrabold uppercase tracking-[0.22em] text-slate-600">{t('contact_page.name')}</span>
                <input
                  type="text"
                  value={form.name}
                  onChange={updateField('name')}
                  className="h-12 rounded border border-slate-200 px-4 text-base text-[#0b1020] outline-none transition focus:border-emerald-500"
                  placeholder={t('contact_page.placeholders.name')}
                  required
                />
              </label>

              <label className="grid gap-2">
                <span className="text-xs font-extrabold uppercase tracking-[0.22em] text-slate-600">{t('contact_page.email')}</span>
                <input
                  type="email"
                  value={form.email}
                  onChange={updateField('email')}
                  className="h-12 rounded border border-slate-200 px-4 text-base text-[#0b1020] outline-none transition focus:border-emerald-500"
                  placeholder={t('contact_page.placeholders.email')}
                  required
                />
              </label>

              <label className="grid gap-2 lg:col-span-2">
                <span className="text-xs font-extrabold uppercase tracking-[0.22em] text-slate-600">{t('contact_page.phone')}</span>
                <input
                  type="tel"
                  value={form.phone}
                  onChange={updateField('phone')}
                  className="h-12 rounded border border-slate-200 px-4 text-base text-[#0b1020] outline-none transition focus:border-emerald-500"
                  placeholder={t('contact_page.placeholders.phone')}
                  required
                />
              </label>

              <label className="grid gap-2 lg:col-span-2">
                <span className="text-xs font-extrabold uppercase tracking-[0.22em] text-slate-600">{t('contact_page.message')}</span>
                <textarea
                  value={form.message}
                  onChange={updateField('message')}
                  className="min-h-36 resize-y rounded border border-slate-200 px-4 py-3 text-base text-[#0b1020] outline-none transition focus:border-emerald-500"
                  placeholder={t('contact_page.placeholders.message')}
                  required
                />
              </label>
            </div>

            <div className="mt-6 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
              <button
                type="submit"
                disabled={!canSubmit || status === 'submitting'}
                className="rounded bg-emerald-500 px-7 py-3 text-sm font-extrabold uppercase text-[#071018] transition hover:bg-emerald-400 disabled:cursor-not-allowed disabled:opacity-60"
              >
                {t('contact_page.submit')}
              </button>
            </div>
          </form>
        </div>
      </section>
      <Footer>{t('contact_page.footer')}</Footer>
    </main>
  );
}

export default ContactPage;
